import React from 'react';
import { theme } from 'codeArt/components/Base';
import { DataContext } from './context';
import { Util } from 'codeArt/common';

//在当前页面的路由表页面进行调用 否则不进行触发调用
export function importData() {
  DataContext.register([
    {
      name: "SCRAP_RATE_REALTIME",
      data: SCRAP_RATE_REALTIME
    },
    {
      name: "LAST_SCRAP_RATE_REALTIME",
      data: ({ arg, dp }) => {
        const _data = Util.clone(LAST_SCRAP_RATE_REALTIME);
        let data = dp.history("SCRAP_RATE_REALTIME");
        //根据data造数据
        let key = `${data[data.length - 2]}-${data[data.length - 1]}`
        return [_data[key] || _data["0.3-0.2"]];
      }
    },

    {
      name: "OUTPUT_REALTIME",
      data: OUTPUT_REALTIME
    },
    {
      name: "LAST_OUTPUT_REALTIME",
      data: ({ arg, dp }) => {
        const _data = Util.clone(LAST_OUTPUT_REALTIME);
        let data = dp.history("OUTPUT_REALTIME");
        //根据data造数据
        let key = `${data[data.length - 2]}-${data[data.length - 1]}`
        return [_data[key] || _data["770-880"]];
      }
    },

    {
      name: "MTBF_REALTIME",
      data: MTBF_REALTIME
    },
    {
      name: "LAST_MTBF_REALTIME",
      data: ({ arg, dp }) => {
        const _data = Util.clone(LAST_MTBF_REALTIME);
        let data = dp.history("MTBF_REALTIME");
        //根据data造数据
        let key = `${data[data.length - 2]}-${data[data.length - 1]}`
        return [_data[key] || _data["29.9-32.4"]];
      }
    },

    {
      name: "OEE_REALTIME",
      data: OEE_REALTIME
    },
    {
      name: "LAST_OEE_REALTIME",
      data: ({ arg, dp }) => {
        const _data = Util.clone(LAST_OEE_REALTIME);
        let data = dp.history("OEE_REALTIME");
        //根据data造数据
        let key = `${data[data.length - 2]}-${data[data.length - 1]}`
        return [_data[key] || _data["0.86-0.91"]];
      }
    }

  ]);

}

const SCRAP_RATE_REALTIME = [  //废品率实况数据
  [0.1, 0.5, 0.3, 0.2],
  [0.1, 0.4, 0.2, 0.5],
  [0.3, 0.4, 0.3, 0.2]
];

const LAST_SCRAP_RATE_REALTIME = {//废品率最后小时数据
  "0.3-0.2": [0.3, 0.26, 0.23, 0.2],
  "0.2-0.5": [0.2, 0.23, 0.3, 0.5],
  "0.3-0.2": [0.3, 0.27, 0.23, 0.2]
};

const OUTPUT_REALTIME = [
  [500, 650, 730, 830],
  [550, 680, 770, 880],
  [590, 680, 790, 950]
];

const LAST_OUTPUT_REALTIME = {
  "730-830": [730, 750, 780, 830],
  "770-880": [770, 800, 840, 880],
  "790-950": [790, 820, 850, 950]
};


const MTBF_REALTIME = [
  [33.2, 21.2, 29.9, 32.4],
  [36.2, 23.2, 24.9, 26.4],
  [35.2, 24.2, 21.9, 27.4]
];

const LAST_MTBF_REALTIME = {
  "29.9-32.4": [29.9, 30.8, 32, 32.4],
  "24.9-26.4": [24.9, 25.5, 25.9, 26.4],
  "21.9-27.4": [21.9, 22, 23.5, 27.4]
};

const OEE_REALTIME = [
  [0.72, 0.85, 0.83, 0.93],
  [0.72, 0.84, 0.85, 0.92],
  [0.75, 0.81, 0.86, 0.91]
];

const LAST_OEE_REALTIME = {
  "0.83-0.93": [0.83, 0.85, 0.88, 0.93],
  "0.85-0.92": [0.85, 0.86, 0.89, 0.92],
  "0.86-0.91": [0.86, 0.875, 0.89, 0.91]
};